<div class="space-y-6">
  <app-page-header
    [backTo]="['/users', user()?.id]"
    backLabel="Retour à la fiche"
    title="Modifier l'utilisateur"
    subtitle="Les modifications sont enregistrées immédiatement après validation du formulaire."
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      (retry)="fetch()"
    />
  } @else if (user(); as u) {
    <app-user-form
      mode="edit"
      [user]="u"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (save)="onSave($event)"
      (cancel)="onCancel()"
    />
  }
</div>
